import { Badge } from "react-bootstrap";

export const subtipoLabels = {
    // ELECTRICIDAD
    'alta_nuevo': 'Alta nueva',
    'cambio_comercializador': 'Cambio de comercializador',
    'cambio_comercializador_potencia': 'Cambio de comercializador y potencia',
    'cambio_comercializador_autoconsumo': 'Cambio de comercializador y autoconsumo',
    'cambio_comercializador_potencia_autoconsumo': 'Cambio de comercializador, potencia y autoconsumo',
    'cambio_titular': 'Cambio de titular',
    'cambio_titular_potencia': 'Cambio de titular y potencia',
    'cambio_titular_autoconsumo': 'Cambio de titular y autoconsumo',
    'cambio_titular_potencia_autoconsumo': 'Cambio de titular, potencia y autoconsumo',
    'cambio_comerc_titular': 'Cambio de comercializador y titular',
    'cambio_comerc_potencia': 'Cambio de comercializador y potencia',
    'cambio_comerc_autoconsumo': 'Cambio de comercializador y autoconsumo',
    'cambio_comerc_titular_potencia': 'Cambio de comercializador, titular y potencia',
    'cambio_comerc_titular_autoconsumo': 'Cambio de comercializador, titular y autoconsumo',
    'cambio_comerc_potencia_autoconsumo': 'Cambio de comercializador, potencia y autoconsumo',
    'cambio_completo': 'Cambio de comercializador, titular, potencia y autoconsumo',
    'renovacion_contrato': 'Renovación de contrato',
    'renovacion_autoconsumo': 'Renovación de contrato y autoconsumo',
    'renovacion_tarifa': 'Renovación de contrato y tarifa de acceso',
    'renovacion_completa': 'Renovación de contrato, autoconsumo y tarifa de acceso',
    // GAS
    'alta_nuevo_gas': 'Alta nuevo suministro Gas',
    'cambio_titular_gas': 'Cambio de titular Gas',
    'cambio_comercializador_gas': 'Cambio de comercializador Gas',
    'cambio_comerc_titular_gas': 'Cambio de comercializador y titular Gas',
    'renovacion_contrato_gas': 'Renovación de contrato Gas',
    'renovacion_tarifa_gas': 'Renovación de contrato y tarifa de acceso Gas'
};

export const sectorTypeBadge = (sector_type) => {
    return sector_type === "electrico" ? (
        <Badge pill bg="warning" text="dark">
            ELECTRICIDAD
        </Badge>
    ) : (
        <Badge pill bg="info" text="dark">
            GAS
        </Badge>
    );
};

export const sectorOptions = [
    { value: "", label: "Todos" },
    { value: "electrico", label: "Eléctrico" },
    { value: "gas", label: "Gas" }
];

export const tipoOptions = [
    { value: "", label: "Todos" },
    { value: "simple", label: "Contrato nuevo" },
    { value: "renovacion", label: "Renovación" }
];

export const stageOptions = [
    { value: 9, label: "Solicitud oferta" },
    { value: 11, label: "Oferta aceptada" }, //ETAPA YA NO SE USA
    { value: 13, label: "Contrato enviado" },
    { value: 14, label: "Firmado" },
    { value: 15, label: "Pendiente solicitud ATR" },
    { value: 16, label: "Solicitud ATR" },
    { value: 17, label: "Aceptada sol. ATR" },
    { value: 18, label: "Rechazada sol. ATR" },
    { value: 19, label: "Contrato activado" },
    { value: 12, label: "Oferta cancelada" },
    { value: 31, label: "Oferta rechazada" }
];

// Mapeo de nombres de etapa que llegan del ERP a las etiquetas que mostramos
// en la UI. Permite renombrar visualmente sin tocar el ERP.
const stageLabelOverrides = {
    "Oferta no aceptada": "Oferta cancelada",
};

export const formatStageName = (stateName) => {
    if (!stateName) return stateName;
    return stageLabelOverrides[stateName] || stateName;
};

// Construye la etiqueta visual del estado para la UI.
// Si la oferta está en "Contrato enviado" y tiene error de firma, mostramos "Contrato enviado: ERROR".
// return { label: "Contrato enviado: ERROR", hasSignaturitError: true } o { label: "Contrato enviado", hasSignaturitError: false }
export const getOfferStagePresentation = (oferta) => {
    const baseLabel = formatStageName(oferta?.state);
    const hasSignaturitError = baseLabel === 'Contrato enviado' && Boolean(oferta?.has_signaturit_error);

    return {
        label: hasSignaturitError ? `${baseLabel}: ERROR` : baseLabel,
        hasSignaturitError,
    };
};


// Función para determinar el tipo MIME y la extensión
export const determineContentTypeAndExtension = (base64Data) => {
    if (base64Data.startsWith("iVBORw0KGgo")) {
        return { contentType: "image/png", extension: "png" };
    }
    if (base64Data.startsWith("/9j/")) {
        return { contentType: "image/jpeg", extension: "jpg" };
    }
    if (base64Data.startsWith("JVBERi0")) {
        return { contentType: "application/pdf", extension: "pdf" };
    }
    // Añade más tipos si es necesario
    return { contentType: "application/octet-stream", extension: "bin" }; // Valor por defecto
};
